var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('i',{staticClass:"icon icon-spinner icon-spin"}):_c('p',[_vm._v("\n  "+_vm._s(_vm.podsUsage)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }